import FormDropdown, {
    FormDropdownOption,
} from "./FormDropdown";
import { Controller, useFormContext } from "react-hook-form";
import { EmissionsSourceItems } from "../api/models/EmissionsSource";

export type ItemTypeValues = {
    categoryId: number;
    typeId: number;
    itemId: number;
};

type EmissionsSourceItemDetailFormProps = {
    emissionsSourceItems: EmissionsSourceItems | null;
    isLoadingEmissionsSourceItems: boolean;
};

const EmissionsSourceItemDetailForm = ({
    emissionsSourceItems,
    isLoadingEmissionsSourceItems,
}: EmissionsSourceItemDetailFormProps) => {
    const methods = useFormContext<ItemTypeValues>();

    const scopeOptions: FormDropdownOption<number>[] = emissionsSourceItems
        ? emissionsSourceItems.emissionsSourceCategories.map((_) => ({
              value: _.id,
              label: `Scope ${_.scope}`,
          }))
        : [];

    const handleTypeChange = (typeId: number) => {
        const itemsForSelectedType =
            emissionsSourceItems?.emissionsSourceItems.filter(
                (_) => _.typeId === typeId
            ) ?? [];

        if (itemsForSelectedType.length === 1) {
            const itemId = itemsForSelectedType[0].id;
            methods.setValue("itemId", itemId);
        } else {
            methods.setValue("itemId", -1);
        }
    };

    const handleCategoryChange = (categoryId: number) => {
        const typesForSelectedCategory =
            emissionsSourceItems?.emissionsSourceTypes.filter(
                (_) => _.categoryId === categoryId
            ) ?? [];
        if (typesForSelectedCategory.length === 1) {
            const typeId = typesForSelectedCategory[0].id;
            methods.setValue("typeId", typeId);
            handleTypeChange(typeId);
        } else {
            methods.setValue("typeId", -1);
            methods.setValue("itemId", -1);
        }
    };

    return (
        <>
            <Controller
                name="categoryId"
                control={methods.control}
                render={({ field: { onChange, value } }) => (
                    <FormDropdown
                        required
                        isLoadingOptions={isLoadingEmissionsSourceItems}
                        label="Scope"
                        pleaseSelectText="Select Scope"
                        options={scopeOptions}
                        value={value}
                        onChange={(categoryId, option) => {
                            handleCategoryChange(categoryId);
                            onChange(categoryId, option);
                        }}
                        error={methods.formState.errors.categoryId}
                    />
                )}
            />
        </>
    );
};

export default EmissionsSourceItemDetailForm;
